// Times follow the interface language, never the browser's:
// "8 h 00" in French, "8:00 a.m." in English.

/** Locale for dates and times in the given interface language. */
export function localeDates(langue?: string): string {
  return langue?.startsWith('en') ? 'en-CA' : 'fr-CA'
}

function enDate(valeur: Date | string): Date {
  // "HH:MM" (opening hours) is a time of day, not a date.
  const hhmm = typeof valeur === 'string' ? /^(\d{1,2}):(\d{2})$/.exec(valeur) : null
  return hhmm ? new Date(2000, 0, 1, Number(hhmm[1]), Number(hhmm[2])) : new Date(valeur)
}

/** A time of day. Takes a Date, an ISO string or "HH:MM". */
export function formatHeure(valeur: Date | string, langue?: string): string {
  const d = enDate(valeur)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleTimeString(localeDates(langue), { hour: 'numeric', minute: '2-digit' })
}

/** A date with its time: "25 oct. 2026, 8 h 00". */
export function formatDateHeure(valeur: Date | string, langue?: string): string {
  const d = enDate(valeur)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleString(localeDates(langue), {
    day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit',
  })
}
